<div class="selector {{classes}}" #selectorElement [ngClass]="{'active': isActive, 'disabled': disabled, 'selector-sm': size == 'sm'}" (click)="toggleActive()" tabindex="0"
     (focus)="focusGained($event)" (blur)="focusLost($event)"
     (keydown.arrowup)="arrowUp($event)" (keydown.arrowdown)="arrowDown($event)"
     (keydown.enter)="enterPressed($event)" (keydown.tab)="tabPress($event)">

     <div [ngClass]="size !== 'sm' ? 'dropdown-icon' : 'dropdown-icon-sm'">
       <em [ngClass]="isActive ? 'icon-up' : 'icon-down'"></em>
     </div>

  <div class="value" [popover]="isToolTip && innerValue ? getDisplayValue(innerValue) : null" triggers="mouseenter:mouseleave" placement="top">
    <span class="placeholder" *ngIf="!innerValue">{{placeholder}}</span>
    <span class="selected-value" *ngIf="innerValue">{{getDisplayValue(innerValue)}}</span>
  </div>

  <div class="value-list custom__scroll" *ngIf="isActive">
    <div class="inner__value__list">
      <div class="item" *ngFor="let item of values">
        <ng-container *ngIf="!(hideOption && (item.value == 'NOT_AVAILABLE' || item.value == 'FEDERAL_TAX_RETURNS'))">
          <div class="selection" (click)="selectItem(item)" [ngClass]="{'over': item.isOver}">
            {{item.key}}
          </div>
        </ng-container>
        <div class="item" *ngFor="let inner of item.items">
          <div class="selection" (click)="selectItem(inner)">{{inner.key}}</div>
        </div>
      </div>
    </div>
  </div>

</div>
